export interface IBusinessProfileState {
    isLoading: boolean;
    businessProfileData?: IBusinessProfileResponse;
}

export const RECEIVE_BUSINESS_PROFILE = "RECEIVE_BUSINESS_PROFILE";

export interface IReceiveBusinessProfileAction {
    type: typeof RECEIVE_BUSINESS_PROFILE;
    businessProfileData?: IBusinessProfileResponse;
}

export type BusinessProfileActionTypes = IReceiveBusinessProfileAction;

export interface IBusinessProfileResponse {
    CompanyId: string;
    Name: string;
    Address: string;
    City: string;
    State: string;
    Zip: string;
    PhoneNumber: string;
    CreditSafeNumber: string;
    DUNSNumber: string;
    CreditProvider: string;
    Detail: string;
}
